import {ACTION} from './constants';
import request from '../../../../../utils/request';
import {requestConfig} from "../../../../../config/apiResource";
import {hideMainLoader,showMainLoader} from "../../../../actions";
import { formDataGenerator } from "../../../../../utils/common";


export function getGoldCash(serverData,formData, path) {

    let formDataValue, pathValue;
    if (serverData.url) {
        let data = {
            cashDate: "",
        };
        formDataValue = formDataGenerator(data);
        let urlArray = serverData.url.split("/");
        pathValue = urlArray[urlArray.length - 1].includes("gold") ? "gold" : "silver";
    }else{
        formDataValue = formData;
        pathValue = path;
    }
    
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getGoldCash(formDataValue, pathValue))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_GOLD_CASH , data: json.data });
                return json
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Gold Cash data: " + error)
            });
    }
}
